import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import { Role } from '@/helpers/role.js';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import Forbidden from '@/views/GeneralViews/Forbidden.vue';
import Unauthorized from '@/views/GeneralViews/Unauthorized.vue';

const Websites = () => import(/* webpackChunkName: "extra" */ '@/views/Websites/List.vue');

const Login = () => import(/* webpackChunkName: "dashboard" */ '@/views/Login.vue');
const VerifyToken = () => import(/* webpackChunkName: "dashboard" */ '@/views/VerifyToken.vue');

let dashboardMenu = {
  path: '/',
  component: DashboardLayout,
  name: 'Dashboard',
  children: [
    {
      path: '/websites',
      name: 'Websites',
      default: true,
      component: Websites,
      meta: { authorize: [Role.Admin, Role.User] } 
    },
  ]
};

let authPages = {
  path: '/login',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/verify-token',
      name: 'VerifyToken',
      component: VerifyToken
    },
    { 
      path: '/forbidden', 
      name: 'Forbidden',
      component: Forbidden 
    },
    { 
      path: '/unauthorized', 
      name: 'Unauthorized',
      component: Unauthorized 
    },
    { 
      path: '/not-found', 
      name: 'NotFound',
      component: NotFound 
    }
  ]
};

const routes = [
  dashboardMenu,
  authPages
];

export default routes;
